import { create } from 'zustand';

const useMapStateStore = create((set) => ({
  // State
  activeZoom: null,
  effectiveMaxZoom: null, // Max zoom available at current location (from Google MaxZoomService)
  activeLevelSvgId: null,
  initialLevelSvgId: null,
  activeMapType: 'roadmap',
  POIVisible: false,
  resetMap: false,
  svgFocusId: null,
  pendingAmenityModal: false,
  focusAnimationComplete: false,
  hasPendingResidenceFocus: false,
  amenityModalOpen: false,
  tgaiSessionActive: false,
  // Emit callback published by an active TourGuide AI session so place modals
  // opened from the map can report favorite toggles back into the tgai capture
  // pipeline. Null when no session is active.
  emitFavoriteAmenity: null,

  // Actions
  setActiveZoom: (activeZoom) => set({ activeZoom }),
  setEffectiveMaxZoom: (effectiveMaxZoom) => set({ effectiveMaxZoom }),
  setActiveLevelSvgId: (activeLevelSvgId) => set({ activeLevelSvgId }),
  setInitialLevelSvgId: (initialLevelSvgId) => set({ initialLevelSvgId }),
  setActiveMapType: (activeMapType) => set({ activeMapType }),
  setPOIVisible: (POIVisible) => set({ POIVisible }),
  setResetMap: (resetMap) => set({ resetMap }),
  setSvgFocusId: (svgFocusId) => set({ svgFocusId }),
  setPendingAmenityModal: (pendingAmenityModal) => set({ pendingAmenityModal }),
  setFocusAnimationComplete: (focusAnimationComplete) => set({ focusAnimationComplete }),
  setHasPendingResidenceFocus: (hasPendingResidenceFocus) => set({ hasPendingResidenceFocus }),
  setAmenityModalOpen: (amenityModalOpen) => set({ amenityModalOpen }),
  setTgaiSessionActive: (tgaiSessionActive) => set({ tgaiSessionActive }),
  setEmitFavoriteAmenity: (emitFavoriteAmenity) => set({ emitFavoriteAmenity }),
}));

export default useMapStateStore;
